import { useSelector } from "react-redux";
import { RootState } from "../../../store";

export const DashboardScreen = () => {
  const { usuario } = useSelector((state: RootState) => state.ui);
  return (
    <div className="space-5 grid grid-cols-4">
      {usuario && (
        <div className="rounded-lg border-2 bg-white p-8 text-center shadow-lg">
          <div className="flex flex-col items-center justify-center gap-y-4">
            <span className="justify-content-center flex items-center text-center text-4xl font-bold text-gray-800">
              <img src={usuario.fc_avatar} className="" />
            </span>
            <span className="flex flex-col pl-3 ">
              <span className="text-2xl font-bold text-gray-800">
                {usuario.name}
              </span>
              <span className="text-primary">{usuario.email}</span>
            </span>
          </div>
        </div>
      )}
    </div>
  );
};
